<fe-header style="z-index: 10000"></fe-header>
<fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>
<section class="mb-26 mb-sm-20">
    <fe-card-landing-title
        [title]="
            'fe_contact_customer_support_card_landing_title_title' | translate
        "
        [imageSrc]="'images/atencionclientebaner.jpg' | cdn"
        class="mb-26 mb-sm-20"
    ></fe-card-landing-title>
    <div class="container gx-4 gx-sm-0 gx-lg-4 container-customer-support">
        <div class="row gy-22">
            <div class="col-12 col-md-6">
                <div class="container-fluid gx-0 gx-lg-4">
                    <div class="row">
                        <div class="col-2 text-center d-none d-sm-block">
                            <img
                                class="container-img w-100"
                                [src]="'images/folder.png' | cdn"
                                [alt]="
                                    'fe_contact_customer_support_img_alt_questions'
                                        | translate
                                "
                            />
                        </div>
                        <div class="col-12 col-sm-10">
                            <h3
                                class="container-customer-support-subtitles text-fifth fw-bold mb-15"
                            >
                                {{
                                    'fe_contact_customer_support_h3_frequently-questions'
                                        | translate
                                }}
                            </h3>
                            <p
                                class="container-customer-support-content text-fifth"
                            >
                                {{
                                    'fe_contact_customer_support_p_frequently-questions-instructions'
                                        | translate
                                }}
                            </p>
                            <ul class="ps-3">
                                <li>
                                    <fe-button
                                        [style]="'link-tertiary'"
                                        [href]="
                                            'questions/car-rental-conditions-and-policies'
                                                | formatUrl
                                        "
                                        [btnClass]="
                                            'p-0 text-decoration-underline text-start'
                                        "
                                        >{{
                                            'fe_contact_customer_support_link_rental-policy'
                                                | translate
                                        }}</fe-button
                                    >
                                </li>
                                <li>
                                    <fe-button
                                        [style]="'link-tertiary'"
                                        [href]="
                                            'questions/refunds-policy'
                                                | formatUrl
                                        "
                                        [btnClass]="
                                            'p-0 text-decoration-underline text-start'
                                        "
                                        >{{
                                            'fe_contact_customer_support_link_refunds-policy'
                                                | translate
                                        }}</fe-button
                                    >
                                </li>
                                <li>
                                    <fe-button
                                        [style]="'link-tertiary'"
                                        [href]="
                                            'questions/privacy-policy'
                                                | formatUrl
                                        "
                                        [btnClass]="
                                            'p-0 text-decoration-underline text-start'
                                        "
                                        >{{
                                            'fe_contact_customer_support_link_privacy-policy'
                                                | translate
                                        }}</fe-button
                                    >
                                </li>
                            </ul>
                            <fe-button
                                [style]="'tertiary'"
                                [href]="'questions' | formatUrl"
                                >{{
                                    'fe_contact_customer_support_link_view-questions'
                                        | translate
                                }}
                            </fe-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="container-fluid gx-0 gx-lg-4">
                    <div class="row">
                        <div class="col-2 text-center d-none d-sm-block">
                            <img
                                class="container-img w-100"
                                [src]="'images/phone.png' | cdn"
                                [alt]="
                                    'fe_contact_customer_support_img_alt_contact-us'
                                        | translate
                                "
                            />
                        </div>
                        <div class="col-12 col-sm-10">
                            <h3
                                class="container-customer-support-subtitles text-fifth fw-bold mb-15"
                            >
                                {{
                                    'fe_contact_customer_support_h3_call-us'
                                        | translate
                                }}
                            </h3>
                            <p
                                class="container-customer-support-content text-fifth"
                            >
                                {{
                                    'fe_contact_customer_support_p_call-us-instructions'
                                        | translate
                                }}
                            </p>
                            <div class="row mb-27">
                                <div class="col-6">
                                    <p
                                        class="fw-bold container-customer-support-subtitles-small mb-0 text-fifth"
                                    >
                                        {{
                                            'fe_contact_customer_support_call_us_p_customer-service'
                                                | translate
                                        }}
                                    </p>
                                    <p
                                        class="fw-bold container-customer-support-subtitles-small mb-0 text-fifth"
                                    >
                                        {{
                                            'fe_contact_customer_support_call_us_p_rent-outside-mexico'
                                                | translate
                                        }}
                                    </p>
                                </div>
                                <div class="col-6 d-flex align-items-center">
                                    <fe-button
                                        [style]="'link-tertiary'"
                                        [btnClass]="
                                            'p-0 text-decoration-underline text-start'
                                        "
                                        [href]="
                                            'tel:' +
                                            ('fe_core_link_contact-phone'
                                                | translate)
                                        "
                                        >{{
                                            'fe_core_format_link_contact-phone'
                                                | translate
                                        }}</fe-button
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2 text-center d-none d-sm-block">
                            <img
                                class="container-img w-100"
                                [src]="'images/laptop.png' | cdn"
                                [alt]="
                                    'fe_contact_customer_support_img_alt_form'
                                        | translate
                                "
                            />
                        </div>
                        <div class="col-12 col-sm-10">
                            <h3
                                class="container-customer-support-subtitles text-fifth fw-bold mb-15"
                            >
                                {{
                                    'fe_contact_customer_support_h3_contact-form'
                                        | translate
                                }}
                            </h3>
                            <p
                                class="container-customer-support-content text-fifth"
                            >
                                {{
                                    'fe_contact_customer_support_p_contact-form-instructions'
                                        | translate
                                }}
                            </p>
                            <fe-button
                                [style]="'link-tertiary'"
                                [btnClass]="'p-0'"
                                [icon]="'open-link'"
                                [iconPosition]="'right'"
                                [iconFormat]="'png'"
                                class="btn-send-us-message text-start"
                                (onClick)="onClickOpenContactForm()"
                                >{{
                                    'fe_contact_customer_support_button_contact-form'
                                        | translate
                                }}</fe-button
                            >
                            <p
                                class="container-customer-support-content text-fifth d-flex align-items-center"
                            >
                                {{
                                    'fe_contact_customer_support_p_or-send-email'
                                        | translate
                                }}&nbsp;
                                <fe-button
                                    [style]="'link-tertiary'"
                                    [btnClass]="'p-0 text-start'"
                                    [href]="
                                        'mailto:' +
                                        ('fe_core_link_contact-email'
                                            | translate)
                                    "
                                    >{{
                                        'fe_core_format_link_contact-email'
                                            | translate
                                    }}</fe-button
                                >
                            </p>
                            <p
                                class="container-customer-support-content text-fifth"
                            >
                                {{
                                    'fe_contact_customer_support_p_contact-form-outside-mexico'
                                        | translate
                                }}
                            </p>
                            <fe-button
                                [style]="'link-tertiary'"
                                [btnClass]="'p-0'"
                                [icon]="'open-link'"
                                [iconPosition]="'right'"
                                [iconFormat]="'png'"
                                class="btn-send-us-message"
                                [href]="
                                    'fe_core_link_contact_outside_mexico'
                                        | translate
                                "
                                [target]="'_blank'"
                                >{{
                                    'fe_core_format_link_contact_outside_mexico'
                                        | translate
                                }}</fe-button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<swal
    #formContactTemplate
    [width]="'auto'"
    [customClass]="{ popup: 'custom-swal-popup-cancel form-contact-popup' }"
    [showCloseButton]="true"
>
    <ng-container *swalPortal="swalTargets.actions">
        <fe-button
            (onClick)="onClickSendMessage()"
            class="mb-6"
            [style]="'tertiary'"
            [loading]="loadingBtnSendMessage"
            >{{
                'fe_contact_customer_support_form_contact_fe_button_send-message'
                    | translate
            }}</fe-button
        >
    </ng-container>
    <form [formGroup]="formContactSupport">
        <div class="container gx-0 gx-sm-4" *swalPortal="undefined">
            <div class="row mt-16 mb-16 gx-2">
                <div class="col-12 d-flex justify-content-center">
                    <h1 class="form-contact-popup-title fw-bold">
                        {{
                            'fe_contact_customer_support_form_contact_h1_title'
                                | translate
                        }}
                    </h1>
                </div>
            </div>
            <div class="row gx-2">
                <div class="col-12 d-flex justify-content-center">
                    <h3 class="form-contact-popup-subtitle">
                        {{
                            'fe_contact_customer_support_form_contact_h3_subtitle'
                                | translate
                        }}
                    </h3>
                </div>
            </div>
            <div class="row gx-2">
                <div class="col-12 col-sm-6 mb-6">
                    <fe-input
                        [label]="
                            'fe_contact_customer_support_form_contact_label_name'
                                | translate
                        "
                        [formControlName]="'name'"
                    ></fe-input>
                </div>
                <div class="col-12 col-sm-6 mb-6">
                    <fe-input
                        [label]="
                            'fe_contact_customer_support_form_contact_label_last-name'
                                | translate
                        "
                        [formControlName]="'lastName'"
                    ></fe-input>
                </div>
                <div class="col-12 col-sm-6 mb-6">
                    <fe-input
                        [type]="'email'"
                        [label]="
                            'fe_contact_customer_support_form_contact_label_email'
                                | translate
                        "
                        [formControlName]="'email'"
                    ></fe-input>
                </div>
                <div class="col-12 col-sm-6 mb-6">
                    <fe-input
                        [isSelect]="true"
                        [label]="
                            'fe_contact_customer_support_form_contact_label_rental-office'
                                | translate
                        "
                        [items]="this.rentalOffices"
                        [appendToSelect]="'body'"
                        [formControlName]="'rentalOffice'"
                    ></fe-input>
                </div>
                <div class="col-12">
                    <fe-input
                        class="mb-6"
                        [isSelect]="true"
                        [label]="
                            'fe_contact_customer_support_form_contact_label_subject'
                                | translate
                        "
                        [items]="this.topics"
                        [appendToSelect]="'body'"
                        [formControlName]="'topic'"
                    ></fe-input>
                </div>
                <div class="col-12 col-sm-6">
                    <fe-input
                        class="mb-6"
                        [label]="
                            'fe_contact_customer_support_form_contact_label_reservation-code'
                                | translate
                        "
                    ></fe-input>
                </div>
                <div class="col-12">
                    <fe-input
                        class="mb-6"
                        [label]="
                            'fe_contact_customer_support_form_contact_label_comments'
                                | translate
                        "
                        [isTextarea]="true"
                        [formControlName]="'comments'"
                    ></fe-input>
                </div>
                <div class="col-12">
                    <!--<re-captcha
                        class="container-recaptcha d-flex justify-content-center"
                        [siteKey]="recaptchaSiteKey"
                        formControlName="recaptchaToken"
                    ></re-captcha>-->
                </div>
            </div>
        </div>
    </form>
</swal>
<fe-footer></fe-footer>
